'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by Administrator on 2016/7/6.
                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _GoeasyInputField = require('../GoeasyInputField/GoeasyInputField');

var _GoeasyInputField2 = _interopRequireDefault(_GoeasyInputField);

var _GoeasySelectField = require('../GoeasyInputField/GoeasySelectField');

var _GoeasySelectField2 = _interopRequireDefault(_GoeasySelectField);

var _VerificationCodeInput = require('../GoeasyInputField/VerificationCodeInput');

var _VerificationCodeInput2 = _interopRequireDefault(_VerificationCodeInput);

var _AddressChosenComponentThreeLevel = require('../AddressChosenComponent/AddressChosenComponentThreeLevel');

var _AddressChosenComponentThreeLevel2 = _interopRequireDefault(_AddressChosenComponentThreeLevel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MerchantAuthenticationForm = (_dec = (0, _reduxForm.reduxForm)({
  form: 'merchantAuthenticationForm',
  fields: ['mobile', 'merchantType', 'merchantName', 'contact', 'contactPhone', 'addressId', 'addressDetail', 'organizationNumber', 'verificationCode']
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MerchantAuthenticationForm, _Component);

  function MerchantAuthenticationForm() {
    (0, _classCallCheck3.default)(this, MerchantAuthenticationForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(MerchantAuthenticationForm).call(this));

    _this.state = {
      verifyClick: false,
      waitingTime: 60
    };
    return _this;
  }

  (0, _createClass3.default)(MerchantAuthenticationForm, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
      clearTimeout(this.timeout);
    }
  }, {
    key: 'onVerifyClick',
    value: function onVerifyClick() {
      var _this2 = this;

      var _props = this.props;
      var mobile = _props.fields.mobile;
      var getVerifyCode = _props.getVerifyCode;

      if (getVerifyCode) {
        getVerifyCode(mobile.value);
        this.setState({
          verifyClick: true
        });
        this.interval = setInterval(function () {
          _this2.setState({
            waitingTime: _this2.state.waitingTime - 1
          });
        }, 1000);
        this.timeout = setTimeout(function () {
          clearInterval(_this2.interval);
          _this2.setState({
            verifyClick: false,
            waitingTime: 60
          });
        }, 60000);
      }
    }
  }, {
    key: 'addressChange',
    value: function addressChange(value, level) {
      var onAddressChange = this.props.onAddressChange;

      if (onAddressChange) {
        onAddressChange(value, level);
      }
    }
  }, {
    key: 'merchantTypeChange',
    value: function merchantTypeChange(typeValue) {
      var _props2 = this.props;
      var _props2$fields = _props2.fields;
      var mobile = _props2$fields.mobile;
      var merchantName = _props2$fields.merchantName;
      var contact = _props2$fields.contact;
      var contactPhone = _props2$fields.contactPhone;
      var addressId = _props2$fields.addressId;
      var addressDetail = _props2$fields.addressDetail;
      var organizationNumber = _props2$fields.organizationNumber;
      var onMerchantTypeChange = _props2.onMerchantTypeChange;

      if (onMerchantTypeChange) {
        onMerchantTypeChange({
          mobile: mobile.value,
          merchantType: typeValue,
          merchantName: merchantName.value,
          contact: contact.value,
          contactPhone: contactPhone.value,
          addressId: addressId.value,
          addressDetail: addressDetail.value,
          organizationNumber: organizationNumber.value
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./MerchantAuthenticationForm.scss');
      var _state = this.state;
      var verifyClick = _state.verifyClick;
      var waitingTime = _state.waitingTime;
      var _props3 = this.props;
      var _props3$fields = _props3.fields;
      var mobile = _props3$fields.mobile;
      var merchantType = _props3$fields.merchantType;
      var merchantName = _props3$fields.merchantName;
      var contact = _props3$fields.contact;
      var contactPhone = _props3$fields.contactPhone;
      var addressId = _props3$fields.addressId;
      var addressDetail = _props3$fields.addressDetail;
      var organizationNumber = _props3$fields.organizationNumber;
      var verificationCode = _props3$fields.verificationCode;
      var handleSubmit = _props3.handleSubmit;
      var addressData = _props3.addressData;
      var data = _props3.data;

      var options = [];
      if (data && data.merchantTypeList instanceof Array) {
        options = data.merchantTypeList.map(function (info) {
          return _react2.default.createElement(
            'option',
            { key: info.value,
              value: info.value },
            info.label || info.value
          );
        });
      }
      options.splice(0, 0, _react2.default.createElement(
        'option',
        { key: 'null', value: '' },
        ' -- 请选择 -- '
      ));
      return _react2.default.createElement(
        'form',
        { className: styles.component, onSubmit: handleSubmit },
        _react2.default.createElement(
          'div',
          { className: styles.title },
          '商户认证'
        ),
        _react2.default.createElement(
          _GoeasySelectField2.default,
          { label: '企业类型：', formProps: merchantType,
            onChange: this.merchantTypeChange.bind(this) },
          options
        ),
        _react2.default.createElement(_GoeasyInputField2.default, { label: '待付金额：', disabled: true, inputPlaceholder: '', value: data.money }),
        _react2.default.createElement(_GoeasyInputField2.default, { label: '说明：', disabled: true, inputPlaceholder: '', value: data.illustrate }),
        _react2.default.createElement(_GoeasyInputField2.default, { label: '企业名称：', inputPlaceholder: '', formProps: merchantName }),
        _react2.default.createElement(_GoeasyInputField2.default, { label: '组织代码证：', inputType: '', inputPlaceholder: '', formProps: organizationNumber }),
        _react2.default.createElement(_GoeasyInputField2.default, { label: '联系人：', inputPlaceholder: '', formProps: contact }),
        _react2.default.createElement(_GoeasyInputField2.default, { label: '联系电话：', inputType: '', inputPlaceholder: '', formProps: contactPhone }),
        _react2.default.createElement(
          'div',
          { className: styles.field },
          _react2.default.createElement(_AddressChosenComponentThreeLevel2.default, { label: '地址信息：', labelStyle: { color: '#000' }, formProps: addressId,
            onAddressChange: this.addressChange.bind(this),
            data: addressData })
        ),
        _react2.default.createElement(_GoeasyInputField2.default, { label: '详细地址：', inputType: 'textarea', inputPlaceholder: '', formProps: addressDetail }),
        _react2.default.createElement(_GoeasyInputField2.default, { label: '手机：', inputPlaceholder: '', disabled: verifyClick, formProps: mobile }),
        _react2.default.createElement(_VerificationCodeInput2.default, { click: this.onVerifyClick.bind(this), formProps: verificationCode,
          waitingTime: waitingTime, clicked: verifyClick }),
        _react2.default.createElement('input', { className: styles.btn, type: 'button', onClick: handleSubmit, value: '确定' }),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return MerchantAuthenticationForm;
}(_react.Component), _class2.propTypes = {
  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  closeModalFunc: _react.PropTypes.func,
  handleSubmit: _react.PropTypes.func,
  registerUrl: _react.PropTypes.string,
  hideCloseModalBtn: _react.PropTypes.bool,
  forgetPwdUrl: _react.PropTypes.string,

  data: _react.PropTypes.object,
  addressData: _react.PropTypes.object,
  onMerchantTypeChange: _react.PropTypes.func,
  onAddressChange: _react.PropTypes.func,
  getVerifyCode: _react.PropTypes.func
}, _temp)) || _class);
exports.default = MerchantAuthenticationForm;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MerchantAuthenticationForm/MerchantAuthenticationForm.js
 ** module id = 1372
 ** module chunks = 0
 **/